<script setup>
import { ref, reactive, watch } from "vue";
import { postsData } from "../util/postsData";
import { fetchWpApi } from "../common/functions/fetchWpApi.es6";

const { news } = postsData;
const reactiveNews = reactive({
    items: news,
});
const currentPage = ref(1);

const props = defineProps({
    datas: {
        type: Array,
    },
    totalPage: {
        type: String,
    },
});

if (props.datas) {
    reactiveNews.items = props.datas;
}

watch(
    () => currentPage.value,
    async (newVal) => {
        if (newVal) {
            const fetchedNews = await fetchWpApi("news", `_fields=title,date,link&orderby=date&order=desc&per_page=10&page=${Number(newVal)}`);
            reactiveNews.items = fetchedNews.datas;
        }
    }
);

function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
}
</script>

<template>
    <ul class="news__lists">
        <li class="news__list" v-for="(item, index) in reactiveNews.items" :key="index">
            <a :href="item.link" class="news__link">
                <time class="news__date">{{ formatDate(item.date) }}</time>
                <p class="news__title">{{ item.title.rendered }}</p>
            </a>
        </li>
    </ul>
    <div class="news-pagination" v-if="Number(totalPage) > 0">
        <button class="news-pagination__btn tk-dystopian" :class="{ '-current': currentPage === index }" v-for="index in Number(totalPage)" :key="index" @click="currentPage = index">
            {{ index }}
        </button>
    </div>
</template>
